// extracted by mini-css-extract-plugin
export default {"adminIcon":"styles_adminIcon__uHIWF","adminLink":"styles_adminLink__ktU+S"};